mutation MoveMerchBoardItem(
  $merchOverlayId: ID!
  $productId: ID!
  $direction: StreamToolsMerchMoveDirection!
) {
  result: StreamToolsMoveMerchBoardItem(
    merchOverlayId: $merchOverlayId
    productId: $productId
    direction: $direction
  ) {
    merchOverlayId
    moved
    order
  }
}
